import styled from 'styled-components';

import {
  mediaSmallOnly,
  mediaConfinedNavlessOnly,
} from '@xing-com/layout-tokens';
import { spaceL, spaceXXL } from '@xing-com/tokens';

import { Dropdown as DefaultDropdown } from '../../../../components/dropdown/dropdown';

export const SectionWrapper = styled.div`
  padding: 0 ${spaceL};
  max-width: 1520px;
  margin: 0 auto;

  display: flex;
  flex-direction: column;
  gap: ${spaceXXL};
  width: 100%;
`;
export const HeaderContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  align-items: center;
  gap: ${spaceL};

  @media (min-width: 1024px) {
    grid-template-columns: auto 1fr;
  }
`;

export const Dropdown = styled(DefaultDropdown)`
  max-width: unset;
  width: 100%;

  @media ${mediaSmallOnly} {
    width: 50%;
  }
  @media ${mediaConfinedNavlessOnly} {
    width: 50%;
  }
  @media (min-width: 1024px) and (max-width: 1268px) {
    width: 100%;
  }
  @media (min-width: 1269px) and (max-width: 1655px) {
    width: 50%;
  }
  @media (min-width: 1655px) {
    width: 50%;
  }
`;
